export enum BlockTypeEnum {
  ADD_USER_FEEDBACK = 'ADD_USER_FEEDBACK'
}
